import { createAction, props } from '@ngrx/store';
import { LoginRequest, User } from '../model/auth.interfaces';

export const login = createAction('[Auth] Login', props<{ credentials: LoginRequest }>());

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: User; token: string; refreshToken?: string }>(),
);

export const loginFailure = createAction('[Auth] Login Failure', props<{ error: string }>());

export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');

export const setUser = createAction('[Auth] Set User', props<{ user: User }>());

export const checkAuth = createAction('[Auth] Check Auth State');
